<template>
  <div class="o-component o-component--breadcrumbs" v-if="props.items && props.items.length > 0">
    <div class="m-breadcrumbs" :class="{ 'u-visible@md': !tablet }">
      <div class="o-container a-layout" :class="{ 'o-container--full': props.full }">
        <nav
          :class="!props.wide && !props.full ? 'u-col-start:3@md u-col-end:11@md' : 'u-col-span:12'"
        >
          <ul class="m-breadcrumbs__list" aria-label="{{ 'breadcrumbs'|t }}">
            <li class="m-breadcrumbs__item">
              <a href="/" class="m-breadcrumbs__link">
                Home
              </a>
            </li>
            <li v-for="(item, index) of props.items" class="m-breadcrumbs__item">
              <a
                v-if="item.url != '' && index < (props.items.length - 1)"
                :href="item.url"
                class="m-breadcrumbs__link"
              >
                {{ item.name }}
              </a>
              <span
                v-if="item.url == '' || index === (props.items.length - 1)"
                class="m-breadcrumbs__current"
                aria-current="page"
              >
                {{ item.name }}
              </span>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
const props = defineProps({
  full: {
    type: Boolean,
    default: false,
  },
  wide: {
    type: Boolean,
    default: true,
  },
  tablet: {
    type: Boolean,
    default: true,
  },
  items: {
    type: Array<{ name: string; url: string; }>,
    default: [],
  },
})
</script>
